import type { Epic } from 'Flux/index.js'
import { filter, switchMap, map, catchError } from 'rxjs/operators'
import { of } from 'rxjs'
import { invitationSlice } from '../../Slice/Invitation/InvitationSlice.js'

export const GetAllInvitesEpic: Epic = (action$, state$, { InviteRepository }) => {
  return action$.pipe(
    filter(invitationSlice.actions.getAllInvitesRequest.match),
    switchMap(() => {
      return InviteRepository.getAllInvites().pipe(
        map((invites) => invitationSlice.actions.getAllInvitesRequestSuccess(invites)),
        catchError((error) => of(invitationSlice.actions.getAllInvitesRequestFailure({ error })))
      )
    })
  )
}
